import { takeEvery, put, call, all } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* getProductAccessibilityList(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query !== undefined
        ? apiUrl + "/opa-accessibility" + actions.query
        : actions.page !== undefined
          ? apiUrl + "/oopa-accessibility?page=" + actions.page
          : apiUrl + "/opa-accessibility?page_size=1000";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({
      type: "LIST_PRODUCT_ACCESSIBILITY_RESPONSE_GET",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "LIST_PRODUCT_ACCESSIBILITY_RESPONSE_GET",
      value: error,
    });
  }
}

function* getProductAccessibility(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-accessibility/"
        : apiUrl + "/opa-accessibility/" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "PRODUCT_ACCESSIBILITY_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "PRODUCT_ACCESSIBILITY_RESPONSE_GET", value: error });
  }
}

function* resetProductAccessibility() {
  yield put({ type: "PRODUCT_ACCESSIBILITY_RESPONSE_RESET" });
}

function* addProductAccessibility(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-accessibility";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.createdAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "PRODUCT_ACCESSIBILITY_RESPONSE_ADD",
      value: { ...response, responseStatus },
    });
  } catch (error) {
    yield put({
      type: "PRODUCT_ACCESSIBILITY_RESPONSE_ADD",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* updateProductAccessibility(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const formData = { ...actions.form };

    if (formData.uuid) {
      delete formData.uuid;
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    };

    let url = `${apiUrl}/opa-accessibility/${actions.id}`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.updatedAt || response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "PRODUCT_ACCESSIBILITY_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "PRODUCT_ACCESSIBILITY_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* deleteProductAccessibility(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-accessibility/" + actions.id;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);
    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "PRODUCT_ACCESSIBILITY_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "PRODUCT_ACCESSIBILITY_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* accessibilityProductsAdd(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form.accessibilityFormData),
    };

    let url = `${apiUrl}/opa-accessibility/${actions.form.accessibilityUuid}/products`;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.createdAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "PRODUCTS_ACCESSIBILITY_RESPONSE_ADD",
      value: { ...response, responseStatus },
    });
  } catch (error) {
    yield put({
      type: "PRODUCTS_ACCESSIBILITY_RESPONSE_ADD",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* accessibilityProductsDelete(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form.accessibilityFormData),
    };

    let url = `${apiUrl}/opa-accessibility/${actions.form.accessibilityUuid}/products`;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);
    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "PRODUCTS_ACCESSIBILITY_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "PRODUCTS_ACCESSIBILITY_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* addAccessibilityProduct(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form.accessibilityFormData),
    };

    let url =
      apiUrl + "/opa-product-accessibilities/" + actions.form.productUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }
    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (Array.isArray(response) || response.success) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "ACCESSIBILITY_PRODUCT_RESPONSE_ADD",
      value: { ...response, responseStatus },
    });
  } catch (error) {
    yield put({
      type: "ACCESSIBILITY_PRODUCT_RESPONSE_ADD",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}

function* deleteAccessibilityProducts(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form.accessibilityUuids),
    };

    let url =
      apiUrl + "/opa-product-accessibilities/" + actions.form.productUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "PRODUCT_ACCESSIBILITY_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "PRODUCT_ACCESSIBILITY_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

export function* getSagaProductAccessibilityList() {
  yield takeEvery(
    "GET_LIST_PRODUCT_ACCESSIBILITY",
    getProductAccessibilityList
  );
}

export function* getSagaProductAccessibility() {
  yield takeEvery("GET_PRODUCT_ACCESSIBILITY", getProductAccessibility);
}

export function* resetSagaProductAccessibility() {
  yield takeEvery("RESET_PRODUCT_ACCESSIBILITY", resetProductAccessibility);
}

export function* addSagaProductAccessibility() {
  yield takeEvery("ADD_PRODUCT_ACCESSIBILITY", addProductAccessibility);
}

export function* updateSagaProductAccessibility() {
  yield takeEvery("UPDATE_PRODUCT_ACCESSIBILITY", updateProductAccessibility);
}

export function* deleteSagaProductAccessibility() {
  yield takeEvery("DELETE_PRODUCT_ACCESSIBILITY", deleteProductAccessibility);
}

export function* sagaAccessibilityProductsAdd() {
  yield takeEvery("ACCESSIBILITY_PRODUCTS_ADD", accessibilityProductsAdd);
}

export function* sagaAccessibilityProductsDelete() {
  yield takeEvery("ACCESSIBILITY_PRODUCTS_DELETE", accessibilityProductsDelete);
}

export function* addSagaAccessibilityProduct() {
  yield takeEvery("ADD_ACCESSIBILITY_PRODUCT", addAccessibilityProduct);
}

export function* deleteSagaAccessibilityProducts() {
  yield takeEvery("DELETE_ACCESSIBILITY_PRODUCTS", deleteAccessibilityProducts);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};
